import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { notification } from "antd";
import { getTripByRequestAssignmentId } from "../services/RegistrationService";
import { ITripDetails } from "../components/ServiceUsers/Interfaces/ITripDetails";
import { WandaBookingStatus } from "../types/ApplicationTypes";
import { defaultTripDetails } from "../components/ServiceUsers/ServiceUsersMobile/defaultTripDetails";
import { getPaymentInstrumentByPaymentInstrumentId } from "../services/PaymentService/PaymentInstrumentService";
import {
  CreditCardDetails,
  defaultCreditCardDetails,
} from "../types/PaymentTypes";
import moment from "moment";

interface IParams {
  requestAssignmentId: string;
  personId: string;
  bookingId: string;
  tripStatusId: string;
  favoriteId: string;
  tripDate: string;
}

export const useTripLegs = () => {
  const [tripLegs, setTripLegs] = useState<ITripDetails[]>([]);
  const [selectedLeg, setSelectedLeg] = useState<ITripDetails>(
    defaultTripDetails
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [creditCardDetails, setCreditCardDetails] = useState<CreditCardDetails>(
    defaultCreditCardDetails
  );
  const params = useParams<IParams>();

  const defaultFavoriteId = 0;

  const bookingStatus: { [key: string]: WandaBookingStatus } = {
    "1": WandaBookingStatus.Booked,
    "2": WandaBookingStatus.Canceled,
    "3": WandaBookingStatus.Completed,
  };

  useEffect(() => {
    const fetchTripLegs = async () => {
      try {
        setIsLoading(true);
        const status = bookingStatus[params.tripStatusId];

        const totalTrips = await getTripByRequestAssignmentId({
          requestAssignmentId: Number(params.requestAssignmentId),
          personId: Number(params.personId),
          favoriteId: Number(params.favoriteId) || defaultFavoriteId,
          tripDate: moment.utc(params.tripDate).format(),
        });

        const ccInfo = await getPaymentInstrumentByPaymentInstrumentId(
          totalTrips.personTrips[0].paymentInstrumentId
        );

        setCreditCardDetails(ccInfo);

        const sortedTripLegs = totalTrips.personTrips.sort(
          (tripA: ITripDetails, tripB: ITripDetails) =>
            tripA.bookingId.localeCompare(tripB.bookingId)
        );

        sortedTripLegs.forEach((trip: ITripDetails) => {
          trip.statusDetail = status;
        });
        setTripLegs(sortedTripLegs);

        const tripLeg = sortedTripLegs.find(
          (trip: ITripDetails) => trip.bookingId === params.bookingId
        );
        setSelectedLeg(tripLeg);
      } catch (error) {
        notification.error({
          message: "Error",
          description: "Failed to Fetch Trips",
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchTripLegs();
  }, []);

  return { tripLegs, setTripLegs, selectedLeg, isLoading, creditCardDetails };
};
